import React from 'react';
import {
  Stack,
  Props as StackProps,
} from '@grnhse/seedling/lib/birch/layouts/stack_v2';

type ClickableStackProps = StackProps & {
  onClick: () => void;
};

const ClickableStack = ({ onClick, ...rest }: ClickableStackProps) => {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      style={{ cursor: 'pointer' }}
    >
      <Stack {...(rest as StackProps)} />
    </div>
  );
};

export default ClickableStack;
